export default "\r\n<footer  >\r\n    &copy; All Rights Reserved 2021 | D Exim Solutions Pvt Ltd\r\n</footer>"